var _g, _g2, _path, _path2, _path3, _path4, _g3, _g4, _path5, _path6, _g5, _g6, _path7, _path8, _g7, _g8, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_20161_1096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5127 37.6331C41.0133 37.0196 40.5621 36.1398 39.7704 36.1268C29.664 35.9604 21.2118 36.1472 10.7582 36.7832C9.96742 36.8314 9.55522 37.7311 10.0832 38.3217C13.7464 42.4201 19.0738 45 25.0039 45C31.2595 45 36.8446 42.1291 40.5127 37.6331Z",
    stroke: "#4C4CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64272 15.0579C7.25238 15.7378 7.82746 16.5294 8.60585 16.436C20.1726 15.048 28.6979 14.6341 40.7882 15.3703C41.5749 15.4182 42.1044 14.5873 41.6676 13.9313C38.0829 8.54757 31.9578 5 25.0039 5C17.5757 5 11.0932 9.04797 7.64272 15.0579Z",
    stroke: "#4C4CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_20161_1096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5127 37.6331C41.0133 37.0196 40.5621 36.1398 39.7704 36.1268C29.664 35.9604 21.2118 36.1472 10.7582 36.7832C9.96742 36.8314 9.55522 37.7311 10.0832 38.3217C13.7464 42.4201 19.0738 45 25.0039 45C31.2595 45 36.8446 42.1291 40.5127 37.6331Z",
    stroke: "#4C4CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64272 15.0579C7.25238 15.7378 7.82746 16.5294 8.60585 16.436C20.1726 15.048 28.6979 14.6341 40.7882 15.3703C41.5749 15.4182 42.1044 14.5873 41.6676 13.9313C38.0829 8.54757 31.9578 5 25.0039 5C17.5757 5 11.0932 9.04797 7.64272 15.0579Z",
    stroke: "#4C4CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5127 37.6331C41.0133 37.0196 40.5621 36.1398 39.7704 36.1268C29.664 35.9604 21.2118 36.1472 10.7582 36.7832C9.96742 36.8314 9.55522 37.7311 10.0832 38.3217C13.7464 42.4201 19.0738 45 25.0039 45C31.2595 45 36.8446 42.1291 40.5127 37.6331Z",
    stroke: "#4C4CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64272 15.0579C7.25238 15.7378 7.82746 16.5294 8.60585 16.436C20.1726 15.048 28.6979 14.6341 40.7882 15.3703C41.5749 15.4182 42.1044 14.5873 41.6676 13.9313C38.0829 8.54757 31.9578 5 25.0039 5C17.5757 5 11.0932 9.04797 7.64272 15.0579Z",
    stroke: "#4C4CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5127 37.6331C41.0133 37.0196 40.5621 36.1398 39.7704 36.1268C29.664 35.9604 21.2118 36.1472 10.7582 36.7832C9.96742 36.8314 9.55522 37.7311 10.0832 38.3217C13.7464 42.4201 19.0738 45 25.0039 45C31.2595 45 36.8446 42.1291 40.5127 37.6331Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64272 15.0579C7.25238 15.7378 7.82746 16.5294 8.60585 16.436C20.1726 15.048 28.6979 14.6341 40.7882 15.3703C41.5749 15.4182 42.1044 14.5873 41.6676 13.9313C38.0829 8.54757 31.9578 5 25.0039 5C17.5757 5 11.0932 9.04797 7.64272 15.0579Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_20161_1096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8593 27.4656C44.9878 26.4133 44.172 25.5115 43.1153 25.4264C30.2353 24.3883 20.1843 24.2251 6.88969 24.9245C5.83054 24.9802 4.98957 25.8596 5.08911 26.9156C5.23042 28.4145 5.5372 29.8654 5.99099 31.2496C6.2525 32.0473 7.03156 32.5408 7.87056 32.5118C20.3831 32.0783 30.0602 32.0468 42.1958 32.3747C43.0353 32.3973 43.8109 31.8976 44.0661 31.0975C44.4385 29.9298 44.7065 28.7155 44.8593 27.4656Z",
    stroke: "#E33CD5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_20161_1096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8593 27.4656C44.9878 26.4133 44.172 25.5115 43.1153 25.4264C30.2353 24.3883 20.1843 24.2251 6.88969 24.9245C5.83054 24.9802 4.98957 25.8596 5.08911 26.9156C5.23042 28.4145 5.5372 29.8654 5.99099 31.2496C6.2525 32.0473 7.03156 32.5408 7.87056 32.5118C20.3831 32.0783 30.0602 32.0468 42.1958 32.3747C43.0353 32.3973 43.8109 31.8976 44.0661 31.0975C44.4385 29.9298 44.7065 28.7155 44.8593 27.4656Z",
    stroke: "#E33CD5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8593 27.4656C44.9878 26.4133 44.172 25.5115 43.1153 25.4264C30.2353 24.3883 20.1843 24.2251 6.88969 24.9245C5.83054 24.9802 4.98957 25.8596 5.08911 26.9156C5.23042 28.4145 5.5372 29.8654 5.99099 31.2496C6.2525 32.0473 7.03156 32.5408 7.87056 32.5118C20.3831 32.0783 30.0602 32.0468 42.1958 32.3747C43.0353 32.3973 43.8109 31.8976 44.0661 31.0975C44.4385 29.9298 44.7065 28.7155 44.8593 27.4656Z",
    stroke: "#E33CD5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8593 27.4656C44.9878 26.4133 44.172 25.5115 43.1153 25.4264C30.2353 24.3883 20.1843 24.2251 6.88969 24.9245C5.83054 24.9802 4.98957 25.8596 5.08911 26.9156C5.23042 28.4145 5.5372 29.8654 5.99099 31.2496C6.2525 32.0473 7.03156 32.5408 7.87056 32.5118C20.3831 32.0783 30.0602 32.0468 42.1958 32.3747C43.0353 32.3973 43.8109 31.8976 44.0661 31.0975C44.4385 29.9298 44.7065 28.7155 44.8593 27.4656Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_20161_1096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 20.5C7.66667 18.5 10.3333 18.5 13 20.5C15.6667 22.5 18.3333 22.5 21 20.5C23.6667 18.5 26.3333 18.5 29 20.5C31.6667 22.5 34.3333 22.5 37 20.5C39.6667 18.5 42.3333 18.5 45 20.5",
    stroke: "#00CCCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_20161_1096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 20.5C7.66667 18.5 10.3333 18.5 13 20.5C15.6667 22.5 18.3333 22.5 21 20.5C23.6667 18.5 26.3333 18.5 29 20.5C31.6667 22.5 34.3333 22.5 37 20.5C39.6667 18.5 42.3333 18.5 45 20.5",
    stroke: "#00CCCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5 20.5C7.66667 18.5 10.3333 18.5 13 20.5C15.6667 22.5 18.3333 22.5 21 20.5C23.6667 18.5 26.3333 18.5 29 20.5C31.6667 22.5 34.3333 22.5 37 20.5C39.6667 18.5 42.3333 18.5 45 20.5",
    stroke: "#00CCCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5 20.5C7.66667 18.5 10.3333 18.5 13 20.5C15.6667 22.5 18.3333 22.5 21 20.5C23.6667 18.5 26.3333 18.5 29 20.5C31.6667 22.5 34.3333 22.5 37 20.5C39.6667 18.5 42.3333 18.5 45 20.5",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_20161_1096)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(0.885492 0.464655 0.464655 -0.885492 18.234 39.9812)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.7076,
    cy: 11.3542,
    rx: 1.5,
    ry: 1,
    transform: "rotate(15 33.7076 11.3542)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(0.965926 -0.258819 -0.258819 -0.965926 31.16 39.9835)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5,
    cy: 12,
    rx: 1.5,
    ry: 1,
    transform: "rotate(180 23.5 12)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.7076,
    cy: 8.35415,
    rx: 1.5,
    ry: 1,
    transform: "rotate(15 27.7076 8.35415)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(1 0 0 -1 25 41.75)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.7929,
    cy: 10.5826,
    rx: 1.5,
    ry: 1,
    transform: "rotate(-27.6879 16.7929 10.5826)",
    stroke: "#4C4CFF"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_20161_1096)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(0.885492 0.464655 0.464655 -0.885492 18.234 39.9812)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.7076,
    cy: 11.3542,
    rx: 1.5,
    ry: 1,
    transform: "rotate(15 33.7076 11.3542)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(0.965926 -0.258819 -0.258819 -0.965926 31.16 39.9835)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5,
    cy: 12,
    rx: 1.5,
    ry: 1,
    transform: "rotate(180 23.5 12)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.7076,
    cy: 8.35415,
    rx: 1.5,
    ry: 1,
    transform: "rotate(15 27.7076 8.35415)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(1 0 0 -1 25 41.75)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.7929,
    cy: 10.5826,
    rx: 1.5,
    ry: 1,
    transform: "rotate(-27.6879 16.7929 10.5826)",
    stroke: "#4C4CFF"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(0.885492 0.464655 0.464655 -0.885492 18.234 39.9812)",
    stroke: "#4C4CFF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.7076,
    cy: 11.3542,
    rx: 1.5,
    ry: 1,
    transform: "rotate(15 33.7076 11.3542)",
    stroke: "#4C4CFF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(0.965926 -0.258819 -0.258819 -0.965926 31.16 39.9835)",
    stroke: "#4C4CFF"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5,
    cy: 12,
    rx: 1.5,
    ry: 1,
    transform: "rotate(180 23.5 12)",
    stroke: "#4C4CFF"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.7076,
    cy: 8.35415,
    rx: 1.5,
    ry: 1,
    transform: "rotate(15 27.7076 8.35415)",
    stroke: "#4C4CFF"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(1 0 0 -1 25 41.75)",
    stroke: "#4C4CFF"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.7929,
    cy: 10.5826,
    rx: 1.5,
    ry: 1,
    transform: "rotate(-27.6879 16.7929 10.5826)",
    stroke: "#4C4CFF"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(0.885492 0.464655 0.464655 -0.885492 18.234 39.9812)",
    stroke: "white",
    strokeWidth: 0.5
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.7076,
    cy: 11.3542,
    rx: 1.5,
    ry: 1,
    transform: "rotate(15 33.7076 11.3542)",
    stroke: "white",
    strokeWidth: 0.5
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(0.965926 -0.258819 -0.258819 -0.965926 31.16 39.9835)",
    stroke: "white",
    strokeWidth: 0.5
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5,
    cy: 12,
    rx: 1.5,
    ry: 1,
    transform: "rotate(180 23.5 12)",
    stroke: "white",
    strokeWidth: 0.5
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.7076,
    cy: 8.35415,
    rx: 1.5,
    ry: 1,
    transform: "rotate(15 27.7076 8.35415)",
    stroke: "white",
    strokeWidth: 0.5
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(1 0 0 -1 25 41.75)",
    stroke: "white",
    strokeWidth: 0.5
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.7929,
    cy: 10.5826,
    rx: 1.5,
    ry: 1,
    transform: "rotate(-27.6879 16.7929 10.5826)",
    stroke: "white",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_20161_1096",
    x: 3.01221,
    y: 0.5,
    width: 43.3184,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_20161_1096"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_20161_1096",
    x: 3.01221,
    y: 0.5,
    width: 43.3184,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_20161_1096"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_20161_1096",
    x: 0.580811,
    y: 20,
    width: 48.792,
    height: 17.0132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_20161_1096"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_20161_1096",
    x: 0.580811,
    y: 20,
    width: 48.792,
    height: 17.0132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_20161_1096"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_20161_1096",
    x: 0.5,
    y: 14.5,
    width: 49,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_20161_1096"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_20161_1096",
    x: 0.5,
    y: 14.5,
    width: 49,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_20161_1096"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_20161_1096",
    x: 10.885,
    y: 2.81299,
    width: 28.7952,
    height: 44.187,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_20161_1096"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_20161_1096",
    x: 10.885,
    y: 2.81299,
    width: 28.7952,
    height: 44.187,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_20161_1096"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.5dc343e6b0e07a2f71118fbc42370705.svg";
export { ForwardRef as ReactComponent };